/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Opensubjectgraduation2Inputs */

const de__field_opensubjectgraduation2 = /** @type {(inputs: _Field_Opensubjectgraduation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss offenes Fach`)
};

/**

* @param {_Field_Opensubjectgraduation2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_opensubjectgraduation2 = /** @type {((inputs?: _Field_Opensubjectgraduation2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Opensubjectgraduation2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_opensubjectgraduation2(inputs)
});
export { _field_opensubjectgraduation2 as "_field_openSubjectGraduation" }